"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerTarget = void 0;
var PaymentType_1 = require("./PaymentType");
var PaymentTypeList_1 = require("./PaymentTypeList");
var defs_1 = require("./defs");
var PartnerTarget = (function () {
    function PartnerTarget(target) {
        this.target = target;
    }
    PartnerTarget.from = function (target) {
        return new PartnerTarget(target);
    };
    PartnerTarget.prototype.toPaymentTypeList = function () {
        switch (this.target) {
            case defs_1.PARTNER_TARGET.Dawn: return PaymentTypeList_1.PaymentTypeList.from([new PaymentType_1.PaymentType(defs_1.PAYMENT_TYPE.FORMATION)]);
            case defs_1.PARTNER_TARGET.Processor: return PaymentTypeList_1.PaymentTypeList.from([
                new PaymentType_1.PaymentType(defs_1.PAYMENT_TYPE.SUBSCRIBE),
                new PaymentType_1.PaymentType(defs_1.PAYMENT_TYPE.RECURRENT)
            ]);
            case defs_1.PARTNER_TARGET.WidgetOther:
            case defs_1.PARTNER_TARGET.Widget: return PaymentTypeList_1.PaymentTypeList.from([new PaymentType_1.PaymentType(defs_1.PAYMENT_TYPE.WIDGET)]);
            case defs_1.PARTNER_TARGET.Indi: return PaymentTypeList_1.PaymentTypeList.from([new PaymentType_1.PaymentType(defs_1.PAYMENT_TYPE.CONSULTATION)]);
            case defs_1.PARTNER_TARGET.IndiProduct: return PaymentTypeList_1.PaymentTypeList.from([new PaymentType_1.PaymentType(defs_1.PAYMENT_TYPE.INDI)]);
            case defs_1.PARTNER_TARGET.ChronosPlus: return PaymentTypeList_1.PaymentTypeList.from([
                defs_1.PAYMENT_TYPE.INDI_TRIAL,
                defs_1.PAYMENT_TYPE.INDI_SUBSCRIBE,
                defs_1.PAYMENT_TYPE.INDI,
                defs_1.PAYMENT_TYPE.INDI_PROLONG,
                defs_1.PAYMENT_TYPE.RECURRENT,
            ].map(PaymentType_1.PaymentType.from));
            default: throw new Error("Unknown target '".concat(this.target, "'"));
        }
    };
    PartnerTarget.prototype.is = function (target) {
        return this.target === target;
    };
    PartnerTarget.prototype.toString = function () {
        return this.target;
    };
    return PartnerTarget;
}());
exports.PartnerTarget = PartnerTarget;
